import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { SDWindow } from '@studio/models/studio.model';
import { StudioApiService } from '@studio/services/studio-api.service';

export const SDWindowDataResolver: ResolveFn<SDWindow> = (route: ActivatedRouteSnapshot, _: RouterStateSnapshot) => {
  const studioApiService = inject(StudioApiService);
  return studioApiService.getWindow(parseInt(route.paramMap.get('id')));
};
